import { Box, Typography, useTheme } from "@mui/material";
import Error from "~components/Templates/Error";
import AccessDeniedImage from "~assets/permission-denied-image.png";

const AccessDenied = ({ isSigned }: { isSigned?: boolean }) => {
  const theme: any = useTheme();

  return (
    <Error isSigned={isSigned}>
      <Box
        component="img"
        sx={{ height: 168, width: 168 }}
        src={AccessDeniedImage}
      />
      <Typography
        variant="body1"
        component="span"
        sx={{ color: theme.palette.common.white }}
      >
        opa. parece que você não tem permissão para acessar aqui.
      </Typography>
    </Error>
  );
};

export default AccessDenied;
